export const BLACKLIST_ADD_MODAL_STAGES = {
  close: 'close',
  add: 'add',
  addConfirmation: 'addConfirmation',
};
